import React from 'react'

export default () => <div>Page Not Found</div>



// WEBPACK FOOTER //
// ./src/components/pages/NotFoundPage.js